// Imports => React
import classnames from 'classnames';
import {Props, DefaultProps} from './ac-text-input.proptypes';
import {Fade} from 'react-awesome-reveal';

// Imports => Utilities
import {AcIsSet, AcIsObject, AcIsFunction} from '@asdf-utils';

// Imports => Controller
import AcTextInputController from './ac-text-input.controller';

// Imports => Atoms
import {AcIcon} from '@asdf-atoms';

// Component
class AcTextInput extends AcTextInputController {
  buildError = forceShowError => {
    const {hasError, touched} = this.state;

    if (hasError && !touched && !forceShowError) return null;
    if (hasError === true) return null;

    return (
      <Fade duration={400} key={hasError}>
        <div
          className={this.getErrorClassNames()}
          dangerouslySetInnerHTML={{
            __html: hasError,
          }}
        />
      </Fade>
    );
  };

  buildInstructions = () => {
    const {instructions} = this.props;
    return (
      <div
        className={this.getInstructionsClassNames()}
        dangerouslySetInnerHTML={{
          __html: instructions,
        }}
      />
    );
  };

  buildSuffix = () => {
    const {suffix} = this.props;

    if (!suffix) return null;

    if (AcIsObject(suffix) || AcIsFunction(suffix)) {
      return <span className={'ac-text-input__suffix'}>{suffix}</span>;
    }

    return (
      <span className={classnames('ac-text-input__suffix', this.props.className)}>
        <AcIcon icon={suffix} />
      </span>
    );
  };

  buildAffix = () => {
    const {affix} = this.props;
    if (!affix) return null;
    return (
      <span className={'ac-text-input__affix'}>
        <AcIcon icon={affix} />
      </span>
    );
  };

  buildTextInput = () => {
    const {
      id,
      disabled,
      readonly,
      required,
      maxLength,
      innerRef,
      min,
      max,
      focus,
      autocomplete,
      additional,
      className: _className,
    } = this.props;
    const {name, type, value} = this.state;

    let pattern = null;
    if (type === 'number') pattern = '[-+]?[0-9]*[.,]?[0-9]+';

    let _props = {};

    if (AcIsSet(pattern)) _props = {..._props, pattern};
    if (AcIsSet(min)) _props = {..._props, min};
    if (AcIsSet(max)) _props = {..._props, max};
    _props = {..._props, value};

    if (type === 'number') _props = {..._props, inputMode: 'numeric'};

    if (focus) _props = {..._props, autoFocus: true};

    if (additional) _props = {..._props, ...additional};

    if (type === 'textarea') {
      return (
        <textarea
          name={name}
          id={id}
          aria-labelledby={`label-${id}`}
          placeholder={this.getPlaceholder()}
          className={this.getInputClassNames()}
          disabled={disabled}
          readOnly={readonly}
          autoComplete={autocomplete ? autocomplete : 'new-password'}
          tabIndex={0}
          onChange={this.onChange}
          onKeyUp={this.onKeyUp}
          ref={e => {
            innerRef && innerRef.ref(e);
            return (this.element.current = e);
          }}
          {..._props}
        />
      );
    }

    return (
      <input
        type={type}
        name={name}
        id={id}
        aria-labelledby={`label-${id}`}
        placeholder={this.getPlaceholder()}
        className={classnames(this.getInputClassNames(), _className)}
        required={required}
        disabled={disabled}
        readOnly={readonly}
        pattern={pattern}
        autoComplete={autocomplete ? autocomplete : 'new-password'}
        autoCapitalize={'none'}
        autoCorrect={'none'}
        tabIndex={0}
        maxLength={maxLength || 524288}
        onChange={this.onChange}
        onKeyUp={this.onKeyUp}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        ref={e => {
          innerRef && innerRef.ref(e);
          return (this.element.current = e);
        }}
        {..._props}
      />
    );
  };

  render() {
    const {id, label, disabled, readonly, instructions, affix, suffix, forceShowError} = this.props;
    const {hasError} = this.state;

    return (
      <div
        ref={node => (this.el = node)}
        className={this.getStyleClassNames()}
        disabled={disabled}
        readOnly={readonly}
      >
        <label htmlFor={id}>
          {label && (
            <summary
              id={`label-${id}`}
              className={this.getLabelClassNames()}
              dangerouslySetInnerHTML={{
                __html: label,
              }}
            />
          )}
          <div
            leading-symbol={this.props.leadingSymbol ? this.props.leadingSymbol : null}
            className={'ac-text-input__field-wrp'}
          >
            {affix && this.buildAffix()}
            {suffix && this.buildSuffix()}
            {this.buildTextInput()}
          </div>
          {instructions && this.buildInstructions()}
          {hasError && this.buildError(forceShowError)}
        </label>
      </div>
    );
  }
}

AcTextInput.displayName = 'AcTextInput';
AcTextInput.propTypes = Props;
AcTextInput.defaultProps = DefaultProps;

export {AcTextInput};
export default AcTextInput;
